// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getById, getDataView } from "@insite/client-framework/Store/Data/DataState";
import { RetailUsersApiParameter } from "@synd/App/Services/RetailerManagementServices";
import { CustomAppState } from "@synd/App/Store/Reducers";

export function getRetailerManagementView(state: CustomAppState, parameter: RetailUsersApiParameter) {
    return getDataView(state.xRetailerManagement, parameter);
}

export function getRetailerUser(state: CustomAppState, userId: string | undefined) {
    return getById(state.xRetailerManagement, userId);
}
